module.exports = __webpack_public_path__ + "images/illustrations/illustration-rise-blocks@1x-3093fdeaf19db52f5ce1cce317953a65.webp";